import React from "react"

const PlusCreateIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
            <path d="M6.49996 1.66667L6.49996 12.3333M11.8333 7L1.16663 7" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default PlusCreateIcon